export var prepareCardNumber = function prepareCardNumber(cardNumber) {
  return cardNumber.replace(/[^0-9]/g, '').slice(-4);
};